"use client";

import Card from "@mui/material/Card";
import styled from "@mui/material/styles/styled";
export const StyledCard = styled(Card)(({
  theme
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(3.25),
  "& .shop-avatar": {
    width: 100,
    height: 100
  },
  "& .shop-name": {
    fontSize: 17,
    textAlign: "center",
    fontWeight: 500,
    marginTop: theme.spacing(1.5),
    color: theme.palette.grey[800]
  }
}));